interface NoteInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function NoteInput({ value, onChange, placeholder = "How are you feeling? Add a note..." }: NoteInputProps) {
  return (
    <div className="animate-fade-up stagger-5" style={{ padding: '0 4px' }}>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={280}
        rows={3}
        aria-label="Mood note"
        style={{
          width: '100%',
          padding: '14px 16px',
          borderRadius: '12px',
          border: '1.5px solid var(--journal-line)',
          background: 'var(--journal-bg)',
          color: 'var(--journal-ink)',
          fontFamily: 'var(--font-body)',
          fontSize: '0.95rem',
          lineHeight: 1.6,
          resize: 'none',
          outline: 'none',
          transition: 'border-color 0.2s, box-shadow 0.2s',
          boxSizing: 'border-box',
        }}
        onFocus={(e) => {
          e.currentTarget.style.borderColor = 'var(--journal-accent)';
          e.currentTarget.style.boxShadow = '0 0 0 3px var(--journal-accent-light)33';
        }}
        onBlur={(e) => {
          e.currentTarget.style.borderColor = 'var(--journal-line)';
          e.currentTarget.style.boxShadow = 'none';
        }}
      />
      <div style={{
        textAlign: 'right',
        fontSize: '0.7rem',
        color: 'var(--journal-ink-faint)',
        marginTop: '4px',
        fontFamily: 'var(--font-body)',
      }}>
        {value.length}/280
      </div>
    </div>
  );
}
